export const passenger_1 = {
  'firstName': 'SAILOR',
  'lastName': 'MOON',
  'middleName': null,
  'birthDate': 'Tue Jun 30 2022',
  'gender': 'male',
  'seatPreference': null,
  'mealPreference': null,
  'specialAsistance': null,
  'knownTravelerNumber': '111',
  'knownTravelerNumberCheck': true,
  'globalEntryNumber': '222',
  'globalEntryNumberCheck': true,
  'tsaPrecheckNumber': '333',
  'tsaPrecheckNumberCheck': true,
  'frequentFlyer':
    [{ 'airline_pk': 123, 'frequent_flyer_number': '132' },
      { 'airline_pk': 123, 'frequent_flyer_number': '321' },
      { 'airline_pk': 123, 'frequent_flyer_number': '555' },
      { 'airline_pk': 97, 'frequent_flyer_number': '666' }],
  'frequentFlyerCheck': true
}
